import { Popup, ErrorPopup, httpAxios } from "../../core/classes/BaseStore";
import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { UserBlocked } from "@/modules/users/viewmodels/UserBlocked";

// state
export const state = {};

export const getters = Object.assign(
  {},
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/users-blockeds",
    UserBlocked,
    {},
    {}
  )
);

// mutations
export const mutations = {};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/users-blockeds",
  [],
  {}
);
